/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";

export class NumberOfDecimalsValidator extends BaseValidator {
	constructor(count) {
		super();

		this.count = count;
	}

	name(model) {
		return "Can only have up to " + this.count + " decimal places.";
	}

	countDecimals(value) {
		if (Math.floor(value) === value) {
			return 0;
		}

		return value.toString().split(".")[1].length || 0;
	}

	logic(x, model, data) {
		if (x != null && !isNaN(x)) {
			let value = Number(x);

			if (this.countDecimals(value) > this.count) {
				return false;
			}
		}

		return true;
	}

	message(model) {
		return this.name(model);
	}
}